<template>
    <div class="gdclmain">
        <van-tabs v-model="active" >
            <van-tab title="物业费">
                <!-- <van-empty image="error" description="暂无数据" v-if="xqbxdcl.length==0" /> -->
                <!--  v-for="(item,index) in xqbxdcl" :key="index" -->
                <div class="item"  v-for="(item,index) in wyfjl" :key="index">
                    <div class="title">
                        <div class="bline"></div>
                        <span>{{item.houseName}}</span>
                        <span class="jine">￥{{item.orderAmount}}</span>
                    </div>
                    <div class="xxj disf" ><span style="color: #333;">缴费区间：</span>
                        <div class="qujian">
                            <span v-for="(it,idx) in item.charges" :key="idx">{{it.startMonth}}至{{it.endMonth}}<span class="jine2">￥{{it.yjfy}}</span></span>
                        </div>
                    </div>
                    <div class="xxj" >缴费时间：<span>{{item.orderTime}}</span></div>
                </div>
            </van-tab>
            <van-tab title="车位费">
                <van-empty image="error" description="暂无数据" v-if="cwfjl.length==0" />
                <div class="item"  v-for="(item,index) in cwfjl" :key="index">
                    <div class="title">
                        <div class="bline"></div>
                        <span>{{item.houseName}}</span>
                        <span class="jine">￥{{item.orderAmount}}</span>
                    </div>
                    <div class="xxj disf" ><span style="color: #333;">缴费区间：</span>
                        <div class="qujian">
                            <span v-for="(it,idx) in item.charges" :key="idx">{{it.startMonth}}至{{it.endMonth}}<span class="jine2">￥{{it.yjfy}}</span></span>
                        </div>
                    </div>
                    <div class="xxj" >缴费时间：<span>{{item.orderTime}}</span></div>
                </div>
            </van-tab>
        </van-tabs>
        <div style="height:50px;width:100%"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            active:'',
            wyfjl:[],
            cwfjl:[]
        }
    },
    watch: {

    },
    mounted() {
        this.getdata(0)
    },
    methods: {
        getdata(page){
            var that = this
            this.$axios.get('/api/v1/allinpay/history/wyf',{
                params:{
                    pageNum:page,
                    pageSize:5,
                    houseId:sessionStorage.getItem('houseId')
                }
            })
            .then(result=>{
                console.log(result)
                that.wyfjl = that.wyfjl.concat(result.data)
                that.wyfjl.forEach(item=>{
                    item.charges.map(it=>{
                        it.endMonth = it.endMonth.substring(0,10)
                        it.startMonth = it.startMonth.substring(0,10)
                    })
                })
            })
            this.$axios.get('/api/v1/allinpay/history/cwf',{
                params:{
                    pageNum:page,
                    pageSize:5,
                    houseId:sessionStorage.getItem('houseId')
                }
            })
            .then(result=>{
                that.cwfjl = that.cwfjl.concat(result.data)
                that.cwfjl.forEach(item=>{
                    item.charges.map(it=>{
                        it.endMonth = it.endMonth.substring(0,10)
                        it.startMonth = it.startMonth.substring(0,10)
                    })
                })
            })
        },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            this.loading = false;
            this.finished = true;
        },
    },
}
</script>
<style lang="less" scpoed>
    .disf{
        display: flex;
    }
    .jine2{
        margin-left: 20px;
            color: #00b5ff !important;
            font-size: 14px;
        }
    .qujian{
        display: flex;
        flex-direction: column;
        justify-content: center;
        
    }
    .gdclmain{
        width: 100%;
        height: calc(100% - 50px);
        font-size: 14px;
        .item{
            width: 100%;
            display: flex;
            flex-direction: column;
            line-height: 30px;
            border-bottom: 1px solid #ebedf0;
            padding: 10px 10px;
            .title{
                color: #333333;
                font-size: 18px;
                display: flex;
                align-items: center;
                position: relative;
                .jine{
                    position: absolute;
                    top: 0px;
                    right: 0;
                    color: #00b5ff;
                    font-size: 14px;
                }
                .bline{
                    width: 4px;
                    height: 20px;
                    background-color: #28aff6;
                }
                span{
                    margin-left: 10px;
                }
            }
            .xxj{
                margin-left: 20px;
                span{
                    color: #999999;
                }
            }
        }
    }
    
</style>